import { notifications } from '@mantine/notifications'
import type { MessagePayload } from 'firebase/messaging'
import type { KeyboardEvent } from 'react'

import ForegroundPushNotification from '../components/ForegroundPushNotification'
import styles from '../components/ForegroundPushNotification.module.scss'
import {
  getSafeNotificationTarget,
  toForegroundNotificationData,
} from './foregroundNotification'

export const showForegroundPushNotification = (message: MessagePayload) => {
  const notification = toForegroundNotificationData(message)
  const target = getSafeNotificationTarget(notification.target)
  const openTarget = () => {
    if (target) window.location.assign(target.href)
  }
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (target && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault()
      openTarget()
    }
  }

  notifications.show({
    position: 'top-right',
    autoClose: 10000,
    withCloseButton: true,
    allowClose: true,
    message: <ForegroundPushNotification {...notification} />,
    classNames: {
      root: styles.notification,
      body: styles.notificationBody,
      description: styles.notificationDescription,
    },
    ...(target && {
      role: 'button',
      tabIndex: 0,
      onClick: openTarget,
      onKeyDown: handleKeyDown,
      'aria-label': `Open notification: ${notification.title}`,
    }),
    'data-testid': 'foreground-push-notification-card',
  })
}
